// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1Pr_Y","messages":"Chat_messages__2Qifr","dateDivider":"Chat_dateDivider__3xuQi"};